import { useProjects } from './useProjects';

/**
 * `GET /allocations` não expõe se o usuário tem projeto no escopo — só se o
 * *filtro atual* não bateu nada. `GET /projects` sem busca já é necessário
 * pro combobox de Projeto (filtro e diálogo); reaproveitado aqui pra
 * distinguir "escopo vazio" de "filtro sem resultado" (T6 de
 * `02-spec-tela-design.md` §5.1).
 */
export function useEmptyScope() {
  const projects = useProjects('');
  return {
    loading: projects.isLoading,
    empty: projects.data ? projects.data.total === 0 : false,
  };
}
